import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop, snaps the viewport to (0, 0) on every route change and on
 * first mount. Disables the browser's native "scrollRestoration" so reload
 * never leaves the user mid-page (e.g. inside the Journey calendar).
 *
 * Hash links (#tools) still scroll to the anchor when explicitly clicked,
 * because we only intercept route-pathname changes.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    if (hash) return; // honor explicit #anchor clicks
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return null;
}
